import CASL from '@/utils/constants/casl'

export default {
  path: 'reward-category',
  name: 'library.reward-category',
  meta: {
    title: 'Reward Category',
    action: 'read',
    subject: CASL.ACCESS.REWARD_CATEGORY
  },
  component: () => import('./RewardCategoryPage.vue')
}
